import request from '../../../shared/request'

export function getLeadNotes(lead_id) {
  return request(`/lead/notes/${lead_id}/`)
}

export function createNote(payload) {
  return request(`/lead/notes/${payload.lead_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateNote(payload) {
  return request(`/lead/notes/${payload.note_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteNote(payload) {
  return request(`/lead/notes/${payload.note_id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/notes.js